import { yupResolver } from '@hookform/resolvers/yup';
import AddIcon from '@mui/icons-material/Add';
import { Button, Stack } from '@mui/material';
import PageHeaderText from 'layout/pages/PageHeaderText';
import PageHeaderWrapper from 'layout/pages/PageHeaderWrapper';
import { isNil } from 'lodash';
import { observer } from 'mobx-react-lite';
import { FormContainer, TextFieldElement, useForm } from 'react-hook-form-mui';
import { object, string } from 'yup';
import type { FC } from 'react';
import type { SubmitHandler } from 'react-hook-form-mui';

interface ProductsFilterData {
  search: string;
}

const ProductsPageHeader: FC<ProductsPageHeaderProps> = observer(
  ({ onSearchChanged, searchTextInit, onCreateClick }) => {
    const schema = object<ProductsFilterData>({
      search: string().max(300),
    }).required();

    const formContext = useForm<ProductsFilterData>({
      mode: 'onChange',
      defaultValues: {
        search: searchTextInit ?? '',
      },
      resolver: yupResolver(schema),
    });

    const filter: SubmitHandler<ProductsFilterData> = (data) => {
      !isNil(onSearchChanged) && onSearchChanged(data.search);
    };

    return (
      <PageHeaderWrapper>
        <PageHeaderText align='center' text='Товары' />
        <Stack direction={'row'} spacing={1} sx={{ alignItems: 'center' }}>
          <FormContainer
            FormProps={{ style: { flexGrow: 1 } }}
            formContext={formContext}
            onSuccess={filter}>
            <TextFieldElement
              size='small'
              fullWidth
              name='search'
              placeholder='Поиск'
              type='search'
            />
          </FormContainer>
          {/* </Box> */}
          <Button startIcon={<AddIcon />} onClick={onCreateClick} variant='contained'>
            Создать
          </Button>
        </Stack>
      </PageHeaderWrapper>
    );
  }
);

export interface ProductsPageHeaderProps {
  searchTextInit?: string;
  onSearchChanged?: (text: string) => void;
  onCreateClick?: VoidFunction;
}

export default ProductsPageHeader;
